import { Carousel, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { listaMasajes } from "../../assets/data/masajes";
import proxVertical from "../../assets/images/prox_vertical.jpg";
import { useState, useEffect } from "react";

const MasajeCaroussel = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // inicial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🔎 Filtrados solo para móvil
  const selectedMasajes = listaMasajes.filter((m) => {
    const alt = m.altTitle?.toLowerCase() || "";
    return (
      alt.includes("relajante") ||
      alt.includes("deportivo") ||
      (alt.includes("descontracturante") && alt.includes("espalda"))
    );
  });

  // 🔧 Filler por si faltan elementos en el carrusel
  const fillerMasajes = [
    {
      title: "Próximamente",
      altTitle: "Proximamente",
      text: "Muy pronto más masajes disponibles.",
      img: proxVertical,
    },
  ];

  const getFillers = (n) => {
    const out = [];
    for (let i = 0; i < n; i++) {
      out.push({ ...fillerMasajes[i % fillerMasajes.length] });
    }
    return out;
  };

  // chunk para escritorio (3 por slide, usando TODOS los masajes)
  const chunkSize = 3;
  const chunkedMasajes = [];
  for (let i = 0; i < listaMasajes.length; i += chunkSize) {
    chunkedMasajes.push(listaMasajes.slice(i, i + chunkSize));
  }

  const CardItem = ({ item }) => (
    <Card className="mb-3 shadow-sm card-hover-effect h-100">
      {item.img && (
        <Card.Img
          variant="top"
          src={item.img}
          alt={item.altTitle}
          className="carousel-card-img"
        />
      )}
      <Card.Body className="d-flex flex-column justify-content-between text-center text-md-start">
        <div>
          <Card.Title>{item.title}</Card.Title>
          <Card.Text>{item.text}</Card.Text>
          {item.precio && (
            <Card.Text>
              <strong>Precio:</strong> {item.precio} €
            </Card.Text>
          )}
        </div>
        {!(item.title?.toLowerCase().includes("proximamente") ||
          item.altTitle?.toLowerCase().includes("proximamente")) && (
            <button
              onClick={() =>
                navigate(`/cita?tipo=${encodeURIComponent(item.altTitle)}`)
              }
              className="btn btn-outline-primary mt-3"
            >
              Reservar este masaje
            </button>
          )}
      </Card.Body>
    </Card>
  );

  return (
    <>
      <h2 className="mx-auto text-center">Reserva ya tu masaje</h2>

      {/* Vista móvil: solo filtrados */}
      {isMobile ? (
        <>
          <Row>
            {selectedMasajes.map((item, index) => (
              <Col xs={12} key={`mobile-${index}`}>
                <CardItem item={item} />
              </Col>
            ))}
          </Row>

          {/* 🔗 Enlace extra en móvil */}
          <div className="text-center mt-3">
            <button
              onClick={() => navigate("/cita")}
              // letra grande
              className="btn btn-primary my-6 px-5 py-4 fs-6"
            >
              Reservar otros masajes
            </button>
          </div>
        </>
      ) : (
        /* Vista escritorio: todos en carrusel */
        <Carousel interval={4000} className="mb-5 fixed-carousel">
          {chunkedMasajes.map((group, idx) => {
            const need = chunkSize - group.length;
            const fullGroup =
              need > 0 ? [...group, ...getFillers(need)] : group;

            return (
              <Carousel.Item key={`slide-${idx}`}>
                <Row>
                  {fullGroup.map((item, index) => (
                    <Col
                      key={`slide-${idx}-col-${index}-${item.title}`}
                      xs={12}
                      sm={6}
                      md={6}
                      lg={4}
                    >
                      <CardItem item={item} />
                    </Col>
                  ))}
                </Row>
              </Carousel.Item>
            );
          })}
        </Carousel>
      )}
    </>
  );
};

export default MasajeCaroussel;
